import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Translate } from "react-redux-i18n";
import styled from "styled-components";
import Constants from "../../AppConstants/Constants";

// region Style
const FlexColumn = styled.div`
    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) {
        //flex: 1;
        //width: 50%;
        margin-bottom: 20px;
    }
`;

const Feature = styled.div`
    .col-md-6:last-of-type & {
        margin-bottom: 0;
    }
  
    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) {
        margin-bottom: 0;
        height: 100%;
    }
`;
// endregion

class Category extends Component {
    render() {
        const { title, description, pageUrl, image, id, config: { DEVICES_CATEGORY_ID } } = this.props;
        return (
            <FlexColumn className="col-md-6 category-link-container">
                <Feature className="feature feature-1 boxed boxed--border">
                    <div className="row">
                        <div className="col-12 col-sm-8 col-md-12 col-lg-8">
                            <h3>{title}</h3>
                            <p>{description}</p>
                            { id === DEVICES_CATEGORY_ID ?
                                <div className="row comparison-link-row">
                                    <Link className="btn btn--sm" to={pageUrl}>
                                        <span className="btn__text text-uppercase"><Translate value="misc.shop" /></span>
                                    </Link>
                                    <span className="comparisonLink">
                                        <p><Translate value="home.devicesBlock.description" /></p>
                                        <Link to={Constants.ENDPOINTS.DEVICE_COMPARISON} style={{ display: "block" }}><Translate value="home.devicesBlock.compare" /></Link>
                                    </span>
                                </div>
                                :
                                <Link className="btn btn--sm" to={pageUrl}>
                                    <span className="btn__text text-uppercase"><Translate value="misc.shop" /></span>
                                </Link>
                            }
                        </div>
                        <div className="col-12 col-sm-4 col-md-12 col-lg-4">
                            <div className="category-image">
                                <img src={image} />
                            </div>
                        </div>
                    </div>
                </Feature>
            </FlexColumn>
        );
    }
}

function mapStateToProps(state) {
    return {
        config: state.config
    };
}

export default withRouter(connect(mapStateToProps)(Category));